<template>
  <div id="login">
    <div class="uk-card uk-padding uk-flex uk-flex-center uk-animation-fade" uk-height-viewport>
      <div class="uk-container uk-container">
        <div class="uk-grid-margin uk-grid uk-grid-stack uk-flex-center" uk-grid>
          <img src="../assets/logo.png" width="400ev" height="250ev" alt uk-img />
        </div>
        <div class="uk-grid-margin uk-grid uk-grid-stack" uk-grid>
          <div class="uk-width-1-1@m">
            <div
              class="uk-margin uk-width-large uk-margin-auto uk-card uk-card-default uk-card-body uk-box-shadow-large uk-border-rounded"
            >
              <h3 class="uk-card-title uk-text-center">Bienvenue</h3>
              <form>
                <div class="uk-margin">
                  <div class="uk-inline uk-width-1-1">
                    <span class="uk-form-icon" uk-icon="icon: mail"></span>
                    <input
                      placeholder="votre.email@exemple.com"
                      class="uk-input uk-form-large uk-border-rounded"
                      type="text"
                      v-model="email"
                    />
                  </div>
                </div>
                <div class="uk-margin">
                  <div class="uk-inline uk-width-1-1">
                    <span class="uk-form-icon" uk-icon="icon: lock"></span>
                    <input
                      v-model="password"
                      v-bind:class="[!passwordMatch ? 'uk-form-danger' : '']"
                      placeholder="Mot de passe"
                      class="uk-input uk-form-large uk-border-rounded"
                      type="password"
                    />
                  </div>
                </div>
                <div class="uk-margin">
                  <button
                    type="button"
                    v-on:submit.prevent="onSubmit"
                    class="uk-button uk-button-primary uk-button-large uk-width-1-1 uk-border-rounded uk-text-bold"
                    v-on:click="signIn()"
                  >Se connecter</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import UIkit from "uikit";
import router from "../router";

export default {
  name: "Login",
  components: {},
  data() {
    return {
      isSignInMod: true,
      email: "",
      password: "",
      passwordConfirmation: "",
      resetPasswordEmailRecuperation: "",
      isLoading: false,
      passwordMatch: true
    };
  },

  mounted() {
    firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
        firebase
          .firestore()
          .collection("Users")
          .doc(firebase.auth().currentUser.uid)
          .get()
          .then(snapshot => {
            var data = snapshot.data();
            data.uid = firebase.auth().currentUser.uid;
            const parsed = JSON.stringify(data);
            localStorage.setItem("currentUser", parsed);
            router.push({ path: "/" });
          })
          .catch(function(error) {
            console.log("Error getting documents: ", error);
          });
        console.log("Connected");
      } else {
        console.log("Not connected");
      }
    });
  },

  methods: {
    signIn: function() {
      this.isLoading = true;
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .catch(error => {
          this.isLoading = false;
          var errorMessage = error.message;
          this.displayErrorMessage(errorMessage);
        });
    },

    isEmail: function() {},

    displayErrorMessage: function(errorMessage) {
      UIkit.notification(
        "<span uk-icon='icon: warning'></span> " + errorMessage,
        { pos: "bottom-center", status: "danger" }
      );
    }

  }
};
</script>

<style scoped>
</style>